export const FOOTNOTE_INDICATOR = '*';
export const AVAILABLE_SPECIALS = 'AVAILABLE_SPECIALS';
export const DEALER_OFFER = 'DEALER_OFFER';
export const DISCLAIMER = 'DISCLAIMER';
export const MANUFACTURER_OFFER = 'MANUFACTURER_OFFER';
export const OFFER_VALID = 'OFFER_VALID';
export const SEE = 'SEE';
export const THROUGH = 'THROUGH';
export const VEHICLE_INCENTIVE = 'VEHICLE_INCENTIVE';
export const DEALERSHIP = 'DEALERSHIP';
export const ONLY_AT = 'ONLY_AT';
export const MANUFACTURER = 'MANUFACTURER';
export const CONDITIONAL = 'CONDITIONAL';
export const CONDITIONAL_SPECIAL = 'CONDITIONAL_SPECIAL';
export const CONDITIONAL_SPECIAL_DESCRIPTION =
	'CONDITIONAL_SPECIAL_DESCRIPTION';



// WEBPACK FOOTER //
// ./src/constants/constants.js